<template>
  <div class="h5-get-device">
    <div class="header">
      <h1>发放设备</h1>
      <button class="back-btn" @click="handleClose">
        <el-icon><ArrowLeft /></el-icon>
      </button>
    </div>
    
    <div class="content">
      <el-form ref="formRef" :model="userData" :rules="rules" label-width="120px">
        <!-- 手机号码 -->
        <el-form-item label="手机号码" prop="mobile">
          <el-input v-model="userData.mobile" placeholder="请输入手机号码"      
           @input="autoSearch"
           @keyup.enter="search" />
        </el-form-item>
            <!-- 用户ID -->
        <el-form-item label="用户ID" prop="userNo">
          <el-input v-model="userData.userNo" placeholder="请输入用户ID"   @blur="search"
    />
        </el-form-item>

        <!-- 选择SPU -->
        <el-form-item label="选择SPU" prop="spuId">
          <el-select v-model="userData.spuId" placeholder="请选择SPU" @change="changeSpu">
            <el-option v-for="(plan, index) in plans" :key="index" :label="plan.name" :value="plan.id" />
          </el-select>
        </el-form-item>
        
        <!-- 选择规格 -->
        <el-form-item label="选择规格" prop="categoryId">
          <el-select v-model="userData.categoryId" placeholder="请选择规格" @change="changeCategory">
            <el-option v-for="(norm, index) in categoryList" :key="index" :label="norm.nickName" :value="norm.id" />
          </el-select>
        </el-form-item>
        
        <!-- 随机发放 -->
        <el-form-item label="随机发放" prop="issueType">
          <el-select v-model="userData.issueType" placeholder="请选择" @change="changeIssueType">
            <el-option :label="'否'" value="1" />
            <el-option :label="'是'" value="2" />
          </el-select>
        </el-form-item>
        
        <!-- 数量 -->
        <el-form-item label="数量" prop="number" v-if="userData.issueType === '2'">
          <el-input v-model.number="userData.number" placeholder="请输入台数" type="number" />
        </el-form-item>
        
        <!-- 选择设备 -->
        <el-form-item label="选择设备" prop="codeList" v-if="userData.issueType === '1'">
          <div class="device-area">
            <el-input
              v-model="userData.codeList"
              type="textarea"
              placeholder="请点击按钮选择设备"
              readonly
              :rows="3"
            />
            <div class="device-buttons">
              <el-button type="primary" @click="selectEquipment" class="select-btn">选择设备</el-button>
              <el-button type="danger" :disabled="!userData.codeList" @click="userData.codeList = ''" class="clear-btn">清除设备</el-button>
            </div>
          </div>
        </el-form-item>
        
        <!-- 随机发放类型 -->
        <el-form-item label="随机发放类型" prop="issueDeviceType" v-if="userData.issueType === '2'">
          <el-select v-model="userData.issueDeviceType" placeholder="请选择" @change="changeIssueDeviceType">
            <el-option :label="'默认随机'" value="1" />
            <el-option :label="'按机房随机'" value="2" />
            <el-option :label="'指定机房随机'" value="3" />
          </el-select>
        </el-form-item>
        
        <!-- 选择机房 -->
        <el-form-item label="选择机房" prop="machineRoom" v-if="userData.issueType === '2' && userData.issueDeviceType === '3'">
          <el-select v-model="userData.machineRoom" placeholder="请选择机房">
            <el-option v-for="room in machineRoomList" :key="room" :label="room" :value="room" />
          </el-select>
        </el-form-item>
        
        <!-- SKU -->
        <el-form-item label="SKU" prop="skuId">
          <el-select v-model="userData.skuId" placeholder="请选择SKU">
            <el-option v-for="sku in skuList" :key="sku.id" :label="sku.nickName" :value="sku.id" />
          </el-select>
        </el-form-item>
        
        <!-- 发放人 -->
        <el-form-item label="发放人" prop="operator">
          <el-select v-model="userData.operator" placeholder="请选择">
          <el-option-group
            v-for="group in options"
            :key="group.deptId"
            :label="group.deptName"
          >
            <el-option
              v-for="item in group.children"
              :key="item.id"
              :label="item.nickName"
              :value="item.id"
            />
          </el-option-group>
        </el-select>
        </el-form-item>
        
        <!-- 大客户经理 -->
        <el-form-item label="大客户经理" prop="keyAccountOperator">
          <el-select v-model="userData.keyAccountOperator" placeholder="请选择大客户经理">
            <el-option v-for="item in keyAccountOperatorNameList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        
        <!-- 支付或发放凭证 -->
        <el-form-item label="支付或发放凭证" prop="payCertificate">
          <div class="upload-area">
             <uploadPayCertificate
                v-model="userData.payCertificate"
                :action="API_CONFIG.uploadAction.url"
                accept="image/*"
                :max-size="10"
                :limit="5"
            ></uploadPayCertificate>
          </div>
        </el-form-item>
        
        <!-- 备注类型 -->
        <el-form-item label="备注类型" prop="remarkType">
          <el-select v-model="userData.remarkType" placeholder="请选择" @change="changeRemarkType">
            <el-option v-for="item in remarkTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        
        <!-- 实际支付金额 -->
        <el-form-item label="实际支付金额" prop="totalPrice">
          <el-input v-model.number="userData.totalPrice" placeholder="请输入实际支付金额" type="number" :disabled="userData.remarkType !== '1'" />
        </el-form-item>
        
        <!-- 备注说明 -->
        <el-form-item label="备注说明" prop="remarkDesc">
          <el-input v-model="userData.remarkDesc" placeholder="请输入备注说明" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
    </div>
    
    <div class="footer">
      <el-button type="primary" :disabled="loading" :loading="loading" @click="submit" class="submit-btn">
        确 定
      </el-button>
    </div>
    
    <!-- 设备选择弹窗 -->
    <div v-if="deviceDialogVisible" class="device-popup-overlay">
      <div class="device-popup">
        <div class="device-popup-header">
          <h3>选择设备</h3>
          <button class="close-btn" @click="deviceDialogVisible = false">
            <span>&times;</span>
          </button>
        </div>
        <div class="device-popup-content">
          <ComSelectDevice ref="comSelectDeviceRef" v-model="codeList" :categoryId="userData.categoryId" />
        </div>
        <div class="device-popup-footer">
          <el-button @click="deviceDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmDeviceSelection">确定</el-button>
        </div>
      </div>
  </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { ElMessage, ElIcon } from "element-plus";
import { ArrowLeft } from "@element-plus/icons-vue";
import request from "@/utils/request.ts";
import { transformToTreeData } from "@/utils/index.ts";
import { getDictData } from "@/utils";
import API_CONFIG from "./api.json"
import uploadPayCertificate from "@/views/userMgt/userPage/components/uploadPayCertificate.vue";
import ComSelectDevice from "@/components/comSelectDevice/index.vue";
import router from "@/router";
import debounce from 'lodash-es/debounce.js';
// 表单数据
const userData = ref({
  userNo: "",
  mobile: "",
  userId: "",
  spuId: "",
  categoryId: "",
  issueType: "2", // 默认否
  number: 1,
  codeList: "",
  issueDeviceType: "1", // 默认默认随机
  machineRoom: "",
  skuId: "",
  operator: "",
  keyAccountOperator: "",
  payCertificate: "",
  remarkType: "",
  totalPrice: 0,
  remarkDesc: ""
});

// 表单引用
const formRef = ref(null);

// 加载状态
const loading = ref(false);

// 设备选择弹窗
const deviceDialogVisible = ref(false);
const comSelectDeviceRef = ref(null);
const codeList = ref([]);

// 套餐列表
const plans = ref([]);

// 规格列表
const categoryList = ref([]);

// SKU列表
const skuList = ref([]);

// 机房列表
const machineRoomList = ref([]);

// 备注类型选项
const remarkTypeOptions = ref([]);

// 发放人选项
const options = ref([]);

// 大客户经理选项
const keyAccountOperatorNameList = ref([]);

// 表单验证规则
const rules = computed(() => {
  const ruleData = {
    spuId: [{ required: true, message: "请选择SPU", trigger: "change" }],
    categoryId: [{ required: true, message: "请选择规格", trigger: "change" }],
    skuId: [{ required: true, message: "请选择SKU", trigger: "change" }],
    payCertificate: [{ required: true, message: "请上传支付或发放凭证", trigger: "change" }],
    remarkType: [{ required: true, message: "请选择备注", trigger: "change" }],
    operator: [{ required: true, message: "请选择发放人", trigger: "change" }],
    totalPrice: [
      { required: true, message: "请输入实际支付金额", trigger: "blur" },
      {
        validator: (rule, value, callback) => {
          if (isNaN(value)) {
            callback(new Error('请输入数字'));
          } else if (value < 0) {
            callback(new Error('金额不能小于0'));
          } else if (userData.value.remarkType == '1' && value == 0) {
            callback(new Error('购买设备金额不能为0'));
          } else if (userData.value.remarkType != '1' && value != 0) {
            callback(new Error('非购买设备金额必须为0'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }
    ]
  };
  
  if (userData.value.issueType == "2") {
    ruleData["number"] = [
      { required: true, message: "请输入台数", trigger: "change" },
      {
        validator: (rule, value, callback) => {
          if (isNaN(value)) {
            callback(new Error('请输入数字'));
          } else if (value < 0) {
            callback(new Error('数量不能小于0'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }
    ];
  }
  
  if (userData.value.issueType == "1") {
    ruleData["codeList"] = [{ required: true, message: "请选择设备", trigger: "blur" }];
  }
  
  return ruleData;
});

// 监听备注类型变化
watch(() => userData.value.remarkType, (newVal) => {
  if (newVal != '1') {
    userData.value.totalPrice = 0;
  }
  setTimeout(() => {
    formRef.value?.clearValidate();
  }, 0);
});

// 初始化数据
onMounted(() => {
  initData();
});

const initData = async () => {
  await getSpuList();
  await getMachineRoomList();
  getRemarkTypeOptions();
  getAllOperator();
  getKeyAccountOperator();
};

// 查询用户信息
const search = () => {
  getUserInfo();
};

const autoSearch = () => {
  // 如果输入值匹配到手机格式，则自动触发搜搜索
  if (/^1[3456789]\d{9}$/.test(userData.value.mobile)){
      search();
  }
}

// 获取用户基础信息
const getUserInfo = () => {
  if (!userData.value.mobile && !userData.value.userNo){
    return ElMessage.error('请输入用户ID或手机号');
  };
  loading.value = true;
  try{
    request
      .post(API_CONFIG.queryUrl.url + `/${userData.value.mobile||userData.value.userNo}`)
      .then(res => {
        if (res.code == "200") {
            userData.value.userNo = res.data.user.userNo;
            userData.value.userId = res.data.user.id;
        } else {
          ElMessage.error(res.msg);
        }
      });
  }catch(e){
  }finally{
    loading.value = false;
  }
};


// 获取发放人
const getAllOperator = () => {
  request
    .post(API_CONFIG.getOperators.url, {
      pageDomain: { pageNum: 1, pageSize: 9999 },
    })
    .then((res) => {
      if (res.code == 200) {
        options.value = transformToTreeData(res.data.data)
      } else {
        options.value = [];
      }
    });
};

// 获取大客户经理
const getKeyAccountOperator = () => {
  request
    .get(API_CONFIG.getKeyAccountOperator.url)
    .then((res) => {
      if (res.code == 200) {
        keyAccountOperatorNameList.value = res.data || [];
      } else {
        keyAccountOperatorNameList.value = [];
      }
    });
};

// 获取商品套餐列表
const getSpuList = async () => {
  try {
    const res = await request.post(API_CONFIG.querySpu.url);
    if (res.code == 200) {
      const hideTypes = getDictData('HIDE_TYPE').filter(ele => ele.value !== 'exchangeCode' && ele.value !== 'saas');
      plans.value = (res.data || []).filter(ele => {
        const currentHideTypes = ele.hideType.split(',').filter(ele => ele !== 'exchangeCode' && ele !== 'saas');
        return ele.status == '0' && hideTypes.length !== currentHideTypes.length;
      });
      
      // 默认选择第一个套餐
      if (plans.value.length > 0) {
        userData.value.spuId = plans.value[0].id;
        changeSpu(plans.value[0].id);
      }
    } else {
      plans.value = [];
    }
  } catch (error) {
    console.error("获取套餐列表失败:", error);
    ElMessage.error("获取套餐列表失败");
  }
};

// 获取机房列表
const getMachineRoomList = async () => {
  try {
    const res = await request.post(API_CONFIG.getMachineRoom.url);
    if (res.code == 200 && res.data) {
      machineRoomList.value = res.data?.machineRoomList || [];
    }
  } catch (error) {
    console.error("获取机房列表失败:", error);
  }
};

// 获取SKU列表
const getSkuList = async () => {
  if (!userData.value.spuId || !userData.value.categoryId) {
    return;
  }
  
  try {
    const params = {
      spuId: userData.value.spuId,
      categoryId: userData.value.categoryId
    };
    const res = await request.post(API_CONFIG.queryCategoryParams.url, params);
    if (res.code === 200) {
      skuList.value =  (res.data.goodsSkuList || [])
    }
  } catch (error) {
    console.error("获取SKU列表失败:", error);
    ElMessage.error("获取SKU列表失败");
  }
};

// 获取备注类型选项
const getRemarkTypeOptions = async () => {
  try {
    const dataDicts = getDictData('DISTRIBUTE_DEVICE_REMARK')
    remarkTypeOptions.value = dataDicts || [];
  } catch (error) {
    console.error("获取备注类型失败:", error);
  }
};

// 套餐变化处理
const changeSpu = (spuId) => {
  userData.value.categoryId = "";
  userData.value.skuId = "";
  skuList.value = [];
   categoryList.value =
    (plans.value || []).find((ele) => ele.id == spuId)?.goodsCategoryList ||
    [];
  userData.value.categoryId =  categoryList.value[0]?.id||'' ;
  getSkuList();
};

// 规格变化处理
const changeCategory = () => {
  userData.value.skuId = "";
  getSkuList();
};

// 发放类型变化处理
const changeIssueType = () => {
  if (userData.value.issueType === '1') {
    userData.value.issueDeviceType = "";
    userData.value.machineRoom = "";
  } else {
    userData.value.codeList = "";
  }
};

// 发放设备类型变化处理
const changeIssueDeviceType = () => {
  if (userData.value.issueDeviceType !== '3') {
    userData.value.machineRoom = "";
  }
};

// 备注类型变化处理
const changeRemarkType = () => {
  if (userData.value.remarkType !== '1') {
    userData.value.totalPrice = 0;
  }
};

// 选择设备
const selectEquipment = () => {
  if (!userData.value.categoryId) {
    ElMessage.error("请先选择规格");
    return;
  }
  deviceDialogVisible.value = true;
   setTimeout(() => {
    comSelectDeviceRef.value.getDeviceList();
    codeList.value = userData.value.codeList ? userData.value.codeList.split(',') : [];
  });
};

// 确认设备选择
const confirmDeviceSelection = () => {
  if (codeList.value.length == 0) {
    ElMessage.warning("请至少选择一台设备");
    return;
  }
  userData.value.codeList = codeList.value.join(',');
  deviceDialogVisible.value = false;
};

// 提交表单
const submit = debounce(async () => {
  if (!formRef.value) return;
  
  try {
    await formRef.value.validate();
    loading.value = true;
    
    const { codeList, spuId, categoryId, skuId, keyAccountOperator, operator, number, userNo, issueType, userId, machineRoom, issueDeviceType, payCertificate, remarkType, remarkDesc, totalPrice } = userData.value;
    
    const params = {
      codeList,
      spuId,
      categoryId,
      skuId,
      number,
      keyAccountOperator,
      operator,
      userNo,
      userId,
      totalPrice,
      payCertificate,
      remark: JSON.stringify({ label: remarkDesc, value: remarkType })
    };

    if (issueType == "2" && issueDeviceType == "2") {
      params.issueType = "3";
    } else if (issueType == "2" && issueDeviceType == "3") {
      params.issueType = "4";
      params.machineRoom = machineRoom;
    } else if (issueType == "2" && issueDeviceType == "1") {
      params.issueType = "2";
    } else if (issueType == "1") {
      params.issueType = "1";
      params.codeList = (params.codeList||[]).split(',');
    }
    if(params.issueType!='1'){
        delete params.codeList
    }

    const res = await request.post(API_CONFIG.reissueDevice.url, params);
    if (res.code == 200) {
      ElMessage.success("发放设备成功");
      // 成功之后带参跳转到设备查询页面
      router.push(`/h5/userDetail?userNo=${userNo}`);
    } else {
      ElMessage.error(res.msg || "发放设备失败");
    }
  } catch (error) {
    console.error("提交失败:", error);
    ElMessage.error("提交失败");
  } finally {
    loading.value = false;
  }
}, 500);

// 关闭页面
const handleClose = () => {
  // 这里可以添加返回逻辑，例如返回上一页
 router.push('/h5/workPlace');
};

// 打开页面并初始化数据
const open = (data) => {
  const { userNo, mobile, id } = data;
  userData.value = {
    userNo,
    mobile,
    userId: id,
    spuId: plans.value[0]?.id || "",
    categoryId: "",
    issueType: "1",
    number: 1,
    codeList: "",
    issueDeviceType: "1",
    machineRoom: "",
    skuId: "",
    operator: "",
    keyAccountOperator: "",
    payCertificate: "",
    remarkType: "",
    totalPrice: 0,
    remarkDesc: ""
  };
  
  // 延迟执行，确保DOM已更新
  setTimeout(() => {
    if (userData.value.spuId) {
      changeSpu(userData.value.spuId);
    }
    formRef.value?.clearValidate();
  });
};

// 暴露方法
defineExpose({
  open
});
</script>

<style scoped>
.h5-get-device {
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.header {
  position: relative;
  background-color: #409eff;
  color: white;
  padding: 16px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.back-btn {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}

.content {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}

.footer {
  padding: 16px;
  background-color: white;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}

.submit-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
}

.device-area {
  width: 100%;
}

.device-buttons {
  margin-top: 12px;
  display: flex;
  gap: 12px;
}

.select-btn,
.clear-btn {
  flex: 1;
}

.upload-area {
  margin-top: 8px;
}

.uploaded-images {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.image-item {
  position: relative;
  width: 80px;
  height: 80px;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.delete-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  padding: 2px;
  z-index: 1;
}

.device-dialog-content {
  max-height: 400px;
}

.device-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
}
.device-popup {
  width: 100%;
  max-height: 80vh;
  background-color: white;
  border-radius: 12px 12px 0 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
.device-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}
.device-popup-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}
.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.device-popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}
.device-popup-footer {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-top: 1px solid #f0f0f0;
  gap: 12px;
}
.device-popup-footer button {
  flex: 1;
}

/* 适配移动端样式 */
@media (max-width: 768px) {
  .content {
    padding: 12px;
  }
  
  .el-form-item {
    margin-bottom: 16px;
  }
  
  .el-form-item__label {
    font-size: 14px;
  }
  
  .el-select,
  .el-input {
    width: 100%;
  }
}
</style>